export default {
  minute: 'Minuto',
  hour: 'Hora',
  day: 'Dia',
  week: 'Semana',
  month: 'Mês',
  quarter: 'Trimestre',
  autoWithPeriod: 'Auto ({period})',
};
